import { render, staticRenderFns } from "./SalesReportsHub.vue?vue&type=template&id=308b44d2&scoped=true"
import script from "./SalesReportsHub.vue?vue&type=script&lang=js"
export * from "./SalesReportsHub.vue?vue&type=script&lang=js"
import style0 from "./SalesReportsHub.vue?vue&type=style&index=0&id=308b44d2&prod&scoped=true&lang=css"
import style1 from "./SalesReportsHub.vue?vue&type=style&index=1&id=308b44d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308b44d2",
  null
  
)

export default component.exports